const homePageSelector = {
  banners: state => state.homePageReducer.banners,
  categoryList: state => state.homePageReducer.categories,
  subCategoryList: state => state.homePageReducer.subCategories,
  topDealProducts: state => state.homePageReducer.topDeals,
  attributeList: state => state.homePageReducer.attributes,
}

export default homePageSelector
